
import Blur from 'vux/src/components/blur/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Range from 'vux/src/components/range/index.vue'

import { DEFAULT_SONG,DEFAULT_IMG,PLAY_MODE_IMG,PLAY_IMG,PAUSE_IMG,PLAYLIST_IMG,NEXT_IMG,PREV_IMG } from "@/config/def";
import { mapMutations, mapState, mapGetters } from 'vuex'
import ProcessBar from './ProcessBar'
import Lyric from './Lyric'
export default {
name: "play",
data() {
return {
curr_cover: DEFAULT_IMG,
iconPlay: PLAY_IMG,
iconPause: PAUSE_IMG,
iconNext: NEXT_IMG,
iconPrev: PREV_IMG,
iconPlaylist: PLAYLIST_IMG
};
},
created () {



},
components: { Blur, XImg, Flexbox, FlexboxItem,Range, ProcessBar,Lyric },
computed: {
bg_height: function () {
return window.innerHeight
},
iconPlayMode: function () {
return PLAY_MODE_IMG[this.playMode]
},
...mapGetters([
'dataUrl','playProcess','duration','currentTime','coverImgUrl'
]),
...mapState({
playing: state => state.PlayService.playing,
playMode: state=>state.PlayService.playMode,
play_full: state => state.PlayService.play_full,
song: state => state.PlayService.song,
setCurrentTime: state => state.PlayService.setCurrentTime,
})
},
methods: {
playFullCtrl() {
this.play_full ? this.$store.commit('playFullDisable') : this.$store.commit('playFullEnable');
},
playCtrl() {
this.playing ? this.$store.commit('pause') : this.$store.commit('play');
},
updateTime() {
let ele = this.$refs.audio;
if(this.playing){
this.$store.commit('updateCurrentTime', parseInt(ele.currentTime))
this.$store.commit('updateDuration', parseInt(ele.duration))
}
},
playAutoEnd: async function(){
this.$store.commit('playEnd')
this.$store.commit('playContinue')
await new Promise((resolve)=>setTimeout(() => {resolve() }, 500)) ;
this.$store.commit('playStart')
},
playNext: async function(){
this.$store.commit('playEnd')
this.$store.commit('playNext')
await new Promise((resolve)=>setTimeout(() => {resolve() }, 500)) ;
this.$store.commit('playStart')
},
playPrev: async function(){
this.$store.commit('playEnd')
this.$store.commit('playPrev')
await new Promise((resolve)=>setTimeout(() => {resolve() }, 500)) ;
this.$store.commit('playStart')
},
...mapMutations([
'play', 'pause','addToPlayList','playIndex','changePlayMode'])
},
watch:{
setCurrentTime(val){
let ele = this.$refs.audio;
ele.currentTime = val;
},
playing(val){
console.log("change playing")
val? this.$refs.audio.play() : this.$refs.audio.pause()
}
}
};




// WEBPACK FOOTER //
// ./src/components/play.vue